import ImageService from "../../services/crud/ImageService";
import { TableProps } from "./types";
import GenericItemsTable, { DefaultColumnMapper } from "./GenericItemsTable";
import { Image as AntImage } from "antd";
import Image, { CreateImageRequest, UpdateImageRequest } from "../../models/Image";
import AccountService from "../../services/crud/AccountService";
import { ImageForm } from "../forms/ImageForm";

async function load(): Promise<Image[]> {

  const [imageList, accounts] = await Promise.all([
    ImageService.list(),
    AccountService.list(),
  ]);

  const list = imageList
  .sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()))
  .map((i) => ({
    ...i,
    updatedAtAsDate: (i as any).updatedAtAsDate,
    //accounts: accounts.filter((a) => i.accountIds?.includes(a.id)).map((a) => `${Account.typeEmoji(a.type)} ${a.name}`),
  } as any));
  return list;
}

export const GenericImagesTable = ({ ...rest }: TableProps<Image>) => {
  return (
    <GenericItemsTable
      actions={{ select: false, edit: true, delete: true, view: true }}
      includeColumns={["name", "alt", "mimeType", "contentHash", "updatedAtAsDate", "actions"]}
      model={Image}
      form={ImageForm}
      onAdd={async (data) => {
        return await ImageService.addImage(new CreateImageRequest(data));
      }}
      onEdit={async (data) => {
        console.log(data);
        return await ImageService.editImage(data.id, new UpdateImageRequest(data));
      }}
      service={ImageService}
      dataLoader={load}
      columnMapper={(col) => {
        col = DefaultColumnMapper(col);
        if (col.key == 'contentHash') {
          col.title = 'Image';
          col.render = (text, record, index) => {
            return <AntImage
              src={Image.getSrcUrl(record)}
              style={{maxHeight: 100}}
            />
          }
        } else if (col.key == 'accounts') {
          col.render = (text, record, index) => {
            const accounts = record?.accounts;
            return (<div style={{whiteSpace:"pre-wrap"}}>
              {`${accounts.join("\n")}`}
            </div>);
          }
        } else if (col.key == 'updatedAtAsDate') {
          col.title = 'Updated At';
        }
        return col;
      }}
      {...rest}></GenericItemsTable>
  );
};

